import { createComponentHealth } from '@apps/admin/common/ComponentHealth';

export const [wrapWithSocialAccountHealthProvider, useSocialAccountHealth] = createComponentHealth('CreateEventFlow | Social Account Intercept');
